<template lang="pug">
  .lithuania
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/lithvenia-min.png"
      )
      span {{ gettext('Литва') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Литва — страна Прибалтики, которая соседствует с Латвией и Эстонией и входит в Европейский Союз. Население Литвы около 3,5 млн. человек, подавляющая часть из которого -  коренные литовцы. Кроме них здесь живут иммигранты из России, Польши, Беларуси, Украины. На сегодня Литва переживает времена, когда молодые специалисты страны отдают предпочтение профессиям белых воротничков либо мигрируют в более развитые страны Европы в поисках заработка. Благодаря этому процессу освобождаются или остаются вовсе незанятыми рабочие места низкоквалифицированных профессий. Это не значит, что хорошему специалисту с высшим образованием не рады в Литве, для такой категории работников предусмотрена особая процедура трудоустройства, более длительная в связи с тщательной проверкой и подтверждением квалификации.') }}
        p {{ gettext('Литва многие годы поддерживает тесные связи со странами бывшего СНГ, поэтому для приезжих из России, Украины и Беларуси работников намного легче адаптироваться к устрою местного общества и найти общий язык (так как большинство литовских граждан знают и понимают русскую речь).') }}
        p {{ gettext('Безработица в Литве составляет — 7,7% и, в первую очередь, местные власти заботятся о занятости местного населения. Несмотря на это, из 5,5 тыс. разрешений на работу выданных Литовской биржей труда в 2017 г  большинство работников было с Украины (61%) и Беларуси (22%).') }}
        p {{ gettext('Особой популярностью среди иностранных работников пользуются профессии в секторе сельского хозяйства, строительства, индустрии, туризма и транспорта, в которых за аналогичный труд они могут выручить в три а то и в пять раз больше денег.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/lithvenia-min.png'})
  },
  name: 'Lithuania',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Lithuania | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/lithuania/index.vue